import { api } from './auth.service';

// ════════════════════════════════════════════════════════════════════════════
// periodo.service.js
// ════════════════════════════════════════════════════════════════════════════

const periodoService = {
  listar: async (params) => {
    const res = await api.get('/periodos', { params });
    return res.data;
  },

  detalhes: async (id) => {
    const res = await api.get(`/periodos/${id}`);
    return res.data;
  },

  podeFechar: async (id) => {
    const res = await api.get(`/periodos/${id}/pode-fechar`);
    return res.data;
  },

  fechar: async (id, usuario_id) => {
    const res = await api.post(`/periodos/${id}/fechar`, { usuario_id });
    return res.data;
  },

  iniciarCorrecoes: async (id, usuario_id, colaboradores) => {
    const res = await api.post(`/periodos/${id}/correcoes`, { usuario_id, colaboradores });
    return res.data;
  },

  finalizarCorrecoes: async (id, usuario_id) => {
    const res = await api.post(`/periodos/${id}/finalizar-correcoes`, { usuario_id });
    return res.data;
  },

  removerColaboradorCorrecao: async (id, colaborador_id) => {
    const res = await api.delete(`/periodos/${id}/correcoes/${colaborador_id}`);
    return res.data;
  },

  colaboradoresComLancamento: async (id) => {
    const res = await api.get(`/periodos/${id}/colaboradores-com-lancamento`);
    return res.data;
  },

  daData: async (data) => {
    const res = await api.get('/periodos/da-data', { params: { data } });
    return res.data;
  },
};

export default periodoService;
